import React from "react";
import { EvtHeader } from "components/header";
import InterviewForm from "../form";
import { useParams } from "react-router-dom";

export default function UpdateOpeningsInterview() {
  const { interviewId } = useParams();
  return (
    <div className="flex-1">
      <EvtHeader title="Edit Interview" />
      <div className="max-w-md p-4 lg:p-6">
        <InterviewForm interviewId={interviewId} />
      </div>
    </div>
  );
};
